import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import LoginButton from '../LoginPage/LoginButton';

const StyledLoginContainer = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const StyledLoginButton = css`
  margin-top: 1rem;
  width: 100%;
`;

const LoginUnauthorized = () => {
  return (
    <StyledLoginContainer>
      <div>
        <span>Sorry, only authorized users are allowed to access this system.</span>
        <LoginButton props={StyledLoginButton} />
      </div>
    </StyledLoginContainer>
  );
};

export default withAuthenticationRequired(LoginUnauthorized, {
  onRedirecting: () => <div>Redirecting you to the login page...</div>,
});
